import { createAsyncThunk } from '@reduxjs/toolkit';
import { clientDetailApi } from '~/apis/clients';
import { IPayloadClientDetailAdminNote, IPayloadClientDetailId, IPayloadUpdateRevenueClient } from '~/pages/clients/Clients.interface';
import { ADD_CLIENT_DETAIL_ADMIN_NOTE, GET_CLIENT_DETAIL, UPDATE_CLIENT_DETAIL_REVENUE } from '~/utils/actionType';

export const getClientDetail = createAsyncThunk(GET_CLIENT_DETAIL, async (payload: IPayloadClientDetailId, { rejectWithValue }) => {
  try {
    const res = await clientDetailApi.getClientDetail(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addClientDetailAdminNote = createAsyncThunk(ADD_CLIENT_DETAIL_ADMIN_NOTE, async (payload: IPayloadClientDetailAdminNote, { rejectWithValue }) => {
  try {
    const res = await clientDetailApi.addClientDetailAdminNote(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateRevenue = createAsyncThunk(UPDATE_CLIENT_DETAIL_REVENUE, async (payload: IPayloadUpdateRevenueClient, { rejectWithValue }) => {
  try {
    const res = await clientDetailApi.updateRevenue(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
